var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768.77 714.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#344d5f;stroke-linecap:round;stroke-linejoin:round;stroke-width:34px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.94,454c-13.52,11.46-21.24,24.69-21.24,38.76,0,44,75.52,79.75,168.68,79.75s168.68-35.7,168.68-79.75c0-11.18-4.87-21.83-13.66-31.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.58,412c-50.88,22.39-83.23,55.34-83.23,92,0,72.39,120,131.07,268,131.07s268-58.68,268-131.07c0-33.79-28.21-64.32-73.09-85.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.23,370C74,403.35,17,456,17,515.32c0,100.73,164.48,182.39,367.38,182.39s367.39-81.66,367.39-182.39c0-56.39-51.55-106.82-132.53-140.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.62,306.79c0,89.41,68.84,161.89,153.76,161.89S549.15,396.2,549.15,306.8c0-99.15-118.75-168.48-153.77-289.8C348,136.7,241.62,207.65,241.62,306.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.25,414.85c56.93,0,102.58-48.59,103.09-108.52,0-30.49-15.28-56.58-34.74-83.08"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIco);
export default __webpack_public_path__ + "static/media/water-ico.1494b772.svg";
export { ForwardRef as ReactComponent };